import React from "react";

// Presenters --------------------------------------------------------//
import Button from "../../presenters/button";

/**
 * Display a banner that redirects to the page
 * to invest in Pandhora's funds.
 *
 * @author Giovanna Marinelli
 */
const InvestBanner = () => {
    return (
        <div className="QueroInvestir">
            <div className="container" style={{ height: "100%" }}>
                <div className="row" style={{ height: "100%" }}>
                    <div className="col-xl-8">
                        <div className="QueroInvestir__title-container">
                            <div className="QueroInvestir__title">
                                Criamos fundos ideais <br /> para
                                <span className="QueroInvestir__title--bold"> construção de patrimônio com </span>
                                <span className="QueroInvestir__title--yellow-bold"> segurança e diversificação.</span>
                            </div>
                        </div>
                    </div>
                    <div className="QueroInvestir__button-container col-xl-4">
                        <a href="https://www.pandhora.com/quero-investir/">
                            <Button className="QueroInvestir__button" color="#FFB800">
                                QUERO INVESTIR
                            </Button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvestBanner;
